import React from 'react';
import styled, { css } from 'styled-components';
import { Row as GridRow } from 'react-grid-system';

const Row = styled(({ align, ...props }) => <GridRow {...props} align={align === 'baseline' ? null : align} />)<{
  fullWidth: boolean;
  align: string;
}>`
  ${({ fullWidth }) => fullWidth && css`
    width: 100%;
  `}

  ${({ align }) => align === 'baseline' && css`
    align-items: ${align};
  `}
`;
// We want to preserve Row as the public name
export { Row as StyledRow };
